import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Pricing from './components/Pricing';
import Contact from './components/RegistroTaller';
import Footer from './components/Footer';

const LandingPage = () => {
  useEffect(() => {
    if (window.lucide) {
      window.lucide.createIcons();
    }
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Services />
        <About />
        <Pricing />
        <Contact /> 
      </main>
      <Footer />
    </>
  );
};

export default LandingPage;